import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-email-change-fail',
  templateUrl: './email-change-fail.component.html',
  styleUrls: ['./email-change-fail.component.scss']
})
export class EmailChangeFailComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<EmailChangeFailComponent>,
    ) { }

  ngOnInit(): void {
  }

}
